/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/resources/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 767);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(8)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ 767:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _App = __webpack_require__(768);

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Vue.component(_App2.default.name, _App2.default);

// dn.one('mount', () => {
//   new Vue({
//     render: h => h(App),
//     el: '#pg-app',
//     parent: dn,
//   });
// });

/***/ }),

/***/ 768:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(769)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(771),
  /* template */
  __webpack_require__(777),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4586afd7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 769:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(770);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4c3cfb8c", content, true, {});

/***/ }),

/***/ 770:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, "#pg-app[data-v-4586afd7]{margin:30px 0}.pg-tab-year-pos[data-v-4586afd7]{display:inline-block}@media (max-width:320px){.pg-tab-year[data-v-4586afd7]{font-size:90%}}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/bible/self/App.vue"],"names":[],"mappings":"AACA,yBAAyB,aAAa,CACrC,AACD,kCAAkC,oBAAoB,CACrD,AACD,yBACA,8BAA8B,aAAa,CAC1C,CACA","file":"App.vue","sourcesContent":["\n#pg-app[data-v-4586afd7]{margin:30px 0\n}\n.pg-tab-year-pos[data-v-4586afd7]{display:inline-block\n}\n@media (max-width:320px){\n.pg-tab-year[data-v-4586afd7]{font-size:90%\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 771:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Year = __webpack_require__(772);

var _Year2 = _interopRequireDefault(_Year);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'dn-bible-self-app',

  components: {
    'dn-pg-year': _Year2.default
  },

  data: function data() {
    return {
      // baseYear: null,
      selected: this.$route.query.year ? 'pg-years-' + this.$route.query.year : null
    };
  },


  computed: {
    baseYear: function baseYear() {
      return this.$store.getters['config/year'];
    },
    years: function years() {
      if (!this.baseYear) return;
      var years = [];
      for (var i = 0; i < 3; i++) {
        years.push(this.baseYear - i - 1);
      }
      return years;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ 772:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(773)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(775),
  /* template */
  __webpack_require__(776),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-66e86712",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 773:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(774);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("0208dc48", content, true, {});

/***/ }),

/***/ 774:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".pg-btn-exec[data-v-66e86712]{display:block;width:80%;margin:10px auto 20px}.pg-score-box[data-v-66e86712]{font-size:20px;text-align:center;line-height:1.2;padding:20px;margin-bottom:30px}.pg-score-box dl[data-v-66e86712]{display:table;margin:0 auto}.pg-score-box dl dt[data-v-66e86712]{padding-right:1em}.pg-score-box dl dd[data-v-66e86712],.pg-score-box dl dt[data-v-66e86712]{display:table-cell;vertical-align:middle}.pg-my-score[data-v-66e86712]{color:#23508f;font-size:120%;font-weight:700}.pg-subject[data-v-66e86712]{margin:30px 0}.pg-subject[data-v-66e86712]:last-child{margin-bottom:0}.pg-subject-table td[data-v-66e86712],.pg-subject-table th[data-v-66e86712]{width:25%;text-align:left;vertical-align:middle}.pg-subject-score[data-v-66e86712]{color:#23508f;white-space:nowrap}.pg-subject-total[data-v-66e86712]{font-size:90%;white-space:nowrap}@media (max-width:320px){.pg-score-box[data-v-66e86712]{padding:10px;font-size:16px}.pg-subject-table td[data-v-66e86712],.pg-subject-table th[data-v-66e86712]{padding-right:5px;padding-left:5px}}@media (max-width:709px){.pg-subject-table[data-v-66e86712]{font-size:90%}}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/bible/self/Year.vue"],"names":[],"mappings":"AACA,8BAA8B,cAAc,UAAU,qBAAqB,CAC1E,AACD,+BAA+B,eAAe,kBAAkB,gBAAgB,aAAa,kBAAkB,CAC9G,AACD,kCAAkC,cAAc,aAAa,CAC5D,AACD,qCAAqC,iBAAiB,CACrD,AACD,0EAA0E,mBAAmB,qBAAqB,CACjH,AACD,8BAA8B,cAAc,eAAe,eAAe,CACzE,AACD,6BAA6B,aAAa,CACzC,AACD,wCAAwC,eAAe,CACtD,AACD,4EAA4E,UAAU,gBAAgB,qBAAqB,CAC1H,AACD,mCAAmC,cAAc,kBAAkB,CAClE,AACD,mCAAmC,cAAc,kBAAkB,CAClE,AACD,yBACA,+BAA+B,aAAa,cAAc,CACzD,AACD,4EAA4E,kBAAkB,gBAAgB,CAC7G,CACA,AACD,yBACA,mCAAmC,aAAa,CAC/C,CACA","file":"Year.vue","sourcesContent":["\n.pg-btn-exec[data-v-66e86712]{display:block;width:80%;margin:10px auto 20px\n}\n.pg-score-box[data-v-66e86712]{font-size:20px;text-align:center;line-height:1.2;padding:20px;margin-bottom:30px\n}\n.pg-score-box dl[data-v-66e86712]{display:table;margin:0 auto\n}\n.pg-score-box dl dt[data-v-66e86712]{padding-right:1em\n}\n.pg-score-box dl dd[data-v-66e86712],.pg-score-box dl dt[data-v-66e86712]{display:table-cell;vertical-align:middle\n}\n.pg-my-score[data-v-66e86712]{color:#23508f;font-size:120%;font-weight:700\n}\n.pg-subject[data-v-66e86712]{margin:30px 0\n}\n.pg-subject[data-v-66e86712]:last-child{margin-bottom:0\n}\n.pg-subject-table td[data-v-66e86712],.pg-subject-table th[data-v-66e86712]{width:25%;text-align:left;vertical-align:middle\n}\n.pg-subject-score[data-v-66e86712]{color:#23508f;white-space:nowrap\n}\n.pg-subject-total[data-v-66e86712]{font-size:90%;white-space:nowrap\n}\n@media (max-width:320px){\n.pg-score-box[data-v-66e86712]{padding:10px;font-size:16px\n}\n.pg-subject-table td[data-v-66e86712],.pg-subject-table th[data-v-66e86712]{padding-right:5px;padding-left:5px\n}\n}\n@media (max-width:709px){\n.pg-subject-table[data-v-66e86712]{font-size:90%\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 775:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var SCORE_EMPTY_STR = '***';
var SHOW_COLUMN = 2;

exports.default = {
  props: {
    year: {
      type: Number,
      required: true
    }
  },

  data: function data() {
    return {
      SCORE_EMPTY_STR: SCORE_EMPTY_STR,
      state: 'pending'
    };
  },


  computed: {
    subjectsStoreName: function subjectsStoreName() {
      return 'selfcheck-' + this.year;
    },
    selfUrl: function selfUrl() {
      return this.$store.getters['path/yearRoot'](this.year) + '/jikosaiten/index.html';
    },
    isLoaded: function isLoaded() {
      return this.state === 'loaded';
    },
    isLoading: function isLoading() {
      return this.state === 'loading';
    },
    myTotalScore: function myTotalScore() {
      return this.totalHistory.score !== null ? this.totalHistory.score : this.SCORE_EMPTY_STR;
    },
    myTotalMax: function myTotalMax() {
      return this.totalHistory.max !== null ? this.totalHistory.max : this.SCORE_EMPTY_STR;
    },
    categories: function categories() {
      return this.isLoaded && this.$store.getters[this.subjectsStoreName + '/categories'];
    },
    totalHistory: function totalHistory() {
      return this.isLoaded && this.$store.getters[this.subjectsStoreName + '/totalHistory'];
    }
  },

  methods: {
    getSubjectScoreById: function getSubjectScoreById(id) {
      var history = this.$store.getters[this.subjectsStoreName + '/subjectHistory'](id);
      return history.fixed && history.selected && history.score;
    },


    /**
     * 科目情報やストレージデータをロードして、visibilityリスナを登録する
     */
    init: function init() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.isLoading || _this.isLoaded)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _this.state = 'loading';
                _context.next = 5;
                return _this.$store.dispatch('loadSelfcheck', _this.year);

              case 5:
                _this.state = 'loaded';

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },


    /**
     * 表示用rowデータを取得する
     */
    subjectsForRows: function subjectsForRows(subjects) {
      var rows = [];
      var rowIndex = -1;

      var _subjects = [];
      subjects.forEach(function (subject) {
        _subjects.push(subject);
        subject.children.forEach(function (child) {
          _subjects.push(child);
        });
      });

      _subjects.forEach(function (subject, index) {
        if (index % SHOW_COLUMN === 0) rowIndex++;
        var row = rows[rowIndex];
        if (!row) {
          row = [];
          rows[rowIndex] = row;
        }
        row.push(subject);
      });

      var diffCount = SHOW_COLUMN - rows[rowIndex].length;
      for (var i = 0; i < diffCount; i++) {
        rows[rowIndex].push({ isEmpty: true });
      }
      return rows;
    }
  },

  created: function created() {
    this.init();
  }
};

/***/ }),

/***/ 776:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pg-year"
  }, [_c('a', {
    staticClass: "pg-btn-exec dn-btn dn-btn--primary dn-btn--text-lg",
    attrs: {
      "href": _vm.selfUrl,
      "target": '_dn_try_old_' + _vm.year
    }
  }, [_vm._v("自己採点を入力する")]), _vm._v(" "), _c('div', {
    staticClass: "pg-score-box dn-box dn-box--gray"
  }, [_c('dl', [_c('dt', [_vm._v("総合得点")]), _vm._v(" "), (_vm.totalHistory) ? _c('dd', [_c('span', {
    staticClass: "pg-my-score"
  }, [_vm._v(_vm._s(_vm.myTotalScore) + "点")]), _vm._v(" "), _c('span', {
    staticClass: "pg-score-separator"
  }, [_vm._v("/")]), _vm._v(" "), _c('span', {
    staticClass: "pg-total-score"
  }, [_vm._v(_vm._s(_vm.myTotalMax) + "点")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "pg-subjects"
  }, _vm._l((_vm.categories), function(category) {
    return _c('section', {
      key: ("categoy_" + (category.id)),
      staticClass: "pg-subject"
    }, [_c('h2', {
      staticClass: "mdTtl02"
    }, [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('table', {
      staticClass: "pg-subject-table dn-table"
    }, _vm._l((_vm.subjectsForRows(category.subjects)), function(row, rowIndex) {
      return _c('tr', {
        key: ("row_" + rowIndex)
      }, [_vm._l((row), function(subject, subjectIndex) {
        return [(subject.isEmpty) ? [_c('th'), _vm._v(" "), _c('td')] : [_c('th', {
          staticClass: "pg-subject-name-cell"
        }, [_vm._v(_vm._s(subject.name))]), _vm._v(" "), _c('td', {
          staticClass: "pg-subject-score-cell"
        }, [_c('span', {
          staticClass: "pg-subject-score"
        }, [_vm._v(_vm._s(_vm.getSubjectScoreById(subject.id) || _vm.SCORE_EMPTY_STR) + "点")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('span', {
          staticClass: "pg-subject-separator"
        }, [_vm._v("/")]), _vm._v(" "), _c('span', {
          staticClass: "pg-subject-total"
        }, [_vm._v(_vm._s(subject.max) + "点")])])])]]
      })], 2)
    }))])
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 777:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pg-app"
    }
  }, [(_vm.years) ? _c('dn-tabs', {
    attrs: {
      "id": "pg-years"
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('dn-tabs-bar', {
    attrs: {
      "slot": "activators"
    },
    slot: "activators"
  }, _vm._l((_vm.years), function(year) {
    return _c('dn-tabs-item', {
      key: year,
      staticClass: "pg-tab-year",
      attrs: {
        "href": '#pg-years-' + year
      }
    }, [_vm._v(_vm._s(year) + "年度"), _c('span', {
      staticClass: "pg-tab-year-pos"
    }, [_vm._v("入試")])])
  })), _vm._v(" "), _vm._l((_vm.years), function(year) {
    return _c('dn-tabs-content', {
      key: year,
      attrs: {
        "id": 'pg-years-' + year
      }
    }, [_c('dn-pg-year', {
      attrs: {
        "year": year
      }
    })], 1)
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ })

/******/ });


// WEBPACK FOOTER //
// bible/self/js/page.js